import { useEffect, useState } from "react";
import { classNames } from "src/helpers/classNames";
import TopMenuItemGroupTitle from "./TopMenuItemGroupTitle";
import TopMenuItemLink from "./TopMenuItemLink";
import TopMenuSubItem from "./TopMenuSubItem";

const TopMenuItemGroup = ({ data, is_sub_group = false, group_id, page_id, searchTerm, setToggleId = () => {}, mordernDesign, handleClick = () => {}, dropdownPosition = "left" }) => {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  const [isSubmenu, setIsSubmenu] = useState(false);
  const [isSubmenuSearchOpened, setIsSubmenuSearchOpened] = useState(false);
  const [imageClassName, setImageClassName] = useState("");
  const [menuItems, setMenuItems] = useState([]);

  const clickMainMenu = () => {
    if (windowWidth <= 1279) {
      setIsSubmenu(!isSubmenu);
    }
  };

  useEffect(() => {
    const handleWindowResize = () => {
      setWindowWidth(window.innerWidth);
    };
    window.addEventListener("resize", handleWindowResize, { passive: true });
    return () => {
      window.removeEventListener("resize", handleWindowResize);
    };
  }, [windowWidth]);

  useEffect(() => {
    if (searchTerm === "") {
      setIsSubmenuSearchOpened(false);
      return;
    }

    data?.submenu?.forEach((singleLink) => {
      if (singleLink?.name?.includes(searchTerm)) {
        setIsSubmenuSearchOpened(true);
        return;
      }
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchTerm]);

  useEffect(() => {
    let visibleMenuItems = data.submenu;
    if (searchTerm) {
      let lowercaseSearchTerm = searchTerm.toLowerCase();
      visibleMenuItems = data.submenu.filter((subitem) => {
        return subitem.name.toLowerCase().includes(lowercaseSearchTerm);
      });
    }
    setMenuItems(visibleMenuItems);
  }, [data.submenu, searchTerm]);

  useEffect(() => {
    if (isSubmenu) {
      setToggleId(data?._id);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSubmenu]);

  useEffect(() => {
    if (windowWidth <= 760 && (data._id === group_id || data.slug === group_id)) {
      setIsSubmenu(true);
    }
  }, [data._id, group_id, data.slug, windowWidth]);

  const getDropdownPositionClass = () => {
    switch (dropdownPosition) {
      case "left":
        return "md:left-0";
      case "right":
        return "md:right-56 md:!-top-0 !mt-0";
      case "center":
        return "md:left-1/2 md:-translate-x-1/2";
      case "bottom-left":
        return "right-0 top-9";
      default:
        return "md:left-0";
    }
  };

  return (
    <div className={classNames("relative", windowWidth > 1279 ? "group/item" : "")}>
      <TopMenuItemGroupTitle
        data={data}
        imageClassName={imageClassName}
        setImageClassName={setImageClassName}
        group_id={group_id}
        page_id={page_id}
        setIsSubmenu={setIsSubmenu}
        isSubmenu={isSubmenu}
        searchTerm={searchTerm}
        avoidUnderlineHover={data.submenu.length > 1}
        handleClick={handleClick}
        clickMainMenu={clickMainMenu}
        windowWidth={windowWidth}
        isSubmenuSearchOpened={isSubmenuSearchOpened}
        mordernDesign={mordernDesign}
        dropdownArrowClass={windowWidth <= 1279 && (isSubmenu || isSubmenuSearchOpened) ? "" : ""}
      />
      {Array.isArray(data.submenu) && data.submenu.length > 1 && (
        <div
          className={classNames(
            "overflow-auto pr-2 transition-all",
            "invisible mt-2 max-h-0 min-w-72 max-w-72 space-y-1 rounded-md bg-leftNavColor py-2 pl-2 opacity-0 group-hover/item:visible group-hover/item:!max-h-[500px] group-hover/item:opacity-100",
            getDropdownPositionClass(),
            // windowWidth > 1279 ? "top-full z-[1] max-h-[600px] min-w-48 overflow-auto rounded-md bg-leftNavColor py-2 pl-2 group-hover/item:visible group-hover/item:!max-h-[8000px] group-hover/item:opacity-100" : "relative pl-4",
            // (windowWidth < 1280 && isSubmenu) || (windowWidth < 1280 && isSubmenuSearchOpened) ? "!visible !max-h-[8000px] !opacity-100" : "invisible !max-h-0 opacity-0",
            is_sub_group ? "relative" : "absolute shadow-md ",
          )}>
          {menuItems.map((subitem) => {
            if (subitem?.is_group) {
              return (
                <TopMenuSubItem
                  key={subitem._id || subitem.page_slug}
                  data={subitem}
                  group_id={group_id}
                  page_id={page_id}
                  searchTerm={searchTerm}
                  handleClick={handleClick}
                />
              );
            }

            return (
              <TopMenuItemLink
                key={subitem.page_slug || subitem._id}
                data={subitem}
                image={subitem?.image}
                group_id={group_id}
                page_id={page_id}
                searchTerm={searchTerm}
                handleClick={handleClick}
              />
            );
          })}
        </div>
      )}
    </div>
  );
};
export default TopMenuItemGroup;
